/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SkuInputs */

const en_field_sku = /** @type {(inputs: Field_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU`)
};

/**
* | output |
* | --- |
* | "SKU" |
*
* @param {Field_SkuInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_sku = /** @type {((inputs?: Field_SkuInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SkuInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_sku(inputs)
});